/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AbsenceReasonDto } from '../models/AbsenceReasonDto';
import type { AbsenceReasonRequest } from '../models/AbsenceReasonRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AbsenceReasonControllerService {
  /**
   * findAll
   * @returns AbsenceReasonDto OK
   * @throws ApiError
   */
  public static findAllUsingGet(): CancelablePromise<Array<AbsenceReasonDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/absence-reason',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * create
   * @returns AbsenceReasonDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: AbsenceReasonRequest;
  }): CancelablePromise<AbsenceReasonDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/absence-reason',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * findByType
   * @returns AbsenceReasonDto OK
   * @throws ApiError
   */
  public static findByTypeUsingGet({
    reasonType,
  }: {
    /**
     * reason-type
     */
    reasonType: 'ABSENCE' | 'LATENESS';
  }): CancelablePromise<Array<AbsenceReasonDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/absence-reason/reason-type',
      query: {
        'reason-type': reasonType,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * findById
   * @returns AbsenceReasonDto OK
   * @throws ApiError
   */
  public static findByIdUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<AbsenceReasonDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/absence-reason/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * update
   * @returns AbsenceReasonDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateUsingPut({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: AbsenceReasonRequest;
  }): CancelablePromise<AbsenceReasonDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/absence-reason/{id}',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * delete
   * @returns any OK
   * @throws ApiError
   */
  public static deleteUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/absence-reason/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
